import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeviceType } from '../../hooks/useDeviceType';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState('en');

  const { isMobile } = useDeviceType();

  // 监听语言变化并更新当前语言状态
  useEffect(() => {
    const updateLanguage = () => {
      const lang = i18n.language || i18n.resolvedLanguage || 'en';
      // 处理完整的语言代码，提取主要语言部分
      const mainLang = lang.toLowerCase().includes('zh') ? 'zh' : 'en';
      setCurrentLang(mainLang);
    };

    // 初始化当前语言
    updateLanguage();

    // 监听语言变化事件
    i18n.on('languageChanged', updateLanguage);

    // 清理监听器
    return () => {
      i18n.off('languageChanged', updateLanguage);
    };
  }, [i18n]);

  const switchLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const containerStyle = {
    display: 'flex',
    gap: isMobile ? '0.3rem' : '0.5rem',
    alignItems: 'center'
  };

  const buttonStyle = (isActive) => ({
    background: isActive
      ? '#4a90e2'
      : 'rgba(74, 144, 226, 0.1)',
    color: isActive ? 'white' : '#4a90e2',
    border: 'none',
    padding: isMobile ? '0.4rem 0.6rem' : '0.5rem 0.8rem',
    borderRadius: '6px',
    fontSize: isMobile ? '0.75rem' : '0.8rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    minWidth: isMobile ? '32px' : 'auto',
    boxShadow: isActive ? '0 2px 8px rgba(74, 144, 226, 0.3)' : 'none'
  });

  return (
    <div style={containerStyle}>
      <button
        onClick={() => switchLanguage('zh')}
        style={buttonStyle(currentLang === 'zh')}
        title="切换到中文"
      >
        中文
      </button>
      <button
        onClick={() => switchLanguage('en')}
        style={buttonStyle(currentLang === 'en')}
        title="Switch to English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher; 
